// extracted by mini-css-extract-plugin
module.exports = {"base-space":"8px","photoOrganizer":"PhotoOrganizer_photoOrganizer__O0ERa","title":"PhotoOrganizer_title__1j4nD","icon":"PhotoOrganizer_icon__spoLQ"};